import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {BenefactorModel, useBenefactorById} from '../../../../entities';
import {useNavigate} from 'react-router';

interface DeleteBenefactorModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  benefactor: BenefactorModel;
}

export const DeleteBenefactorModal = ({open, setOpen, benefactor}: DeleteBenefactorModalProps) => {
  const {deleteBenefactorMutation} = useBenefactorById(benefactor.id);
  const navigate = useNavigate();

  const {
    isErrorModalOpen,
    errorInfo,
    handleError,
    handleClose
  } = useErrorHandler({
    resourceName: 'Удаление пользователя',
  });

  useEffect(() => {
    if (deleteBenefactorMutation.error) {
      handleError(deleteBenefactorMutation.error as unknown as ApiError);
    }
  }, [deleteBenefactorMutation.error, handleError]);

  const handleSubmit = () => {
    deleteBenefactorMutation.mutate(undefined, {
      onSuccess: () => {
        setOpen(false);
        navigate('/accounts/benefactors');
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteBenefactorMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление пользователя'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этого пользователя? Обратите внимание, что это действие безвозвратное.
        </Text>
      </ActionModal>
      <ErrorModal
        open={isErrorModalOpen}
        onClose={handleClose}
        title={errorInfo.title}
        message={errorInfo.message}
      />
    </>
  );
}; 